import React, { ReactNode } from "react";
import { cn } from "../../../styles";
import { useDataTableContext } from "../context";

export interface TableProps {
  children: ReactNode;
  className?: string;
}

export function Table({ children, className }: TableProps) {
  const { dense } = useDataTableContext();

  return (
    <table
      className={cn(
        "w-full border-collapse",
        dense ? "text-sm" : "text-base",
        className
      )}
    >
      {children}
    </table>
  );
}
